<template>
  <b-modal id="update-email-modal"
           title="Update Email"
           ref="updateEmailModal"
           size="md"
           button-size="sm"
           hide-header-close
           no-close-on-backdrop
           no-close-on-esc
           no-stacking
           centered
           @cancel="resetModal">

    <div class="container mb-2 p-0">
      <b-form-group
        id="email"
        label-cols-lg="3"
        content-cols-lg="9"
        label="Email:"
        label-class="font-weight-bold pt-0"
        label-for="email"
        description="Your New Email Address">
        <b-form-input id="email"
                      type="email"
                      name="email"
                      v-model.trim="editedEmail"
                      placeholder="A Valid Email"
                      v-validate="'required|email|max:254'"
                      data-vv-as="Email"
                      data-vv-delay="500"
                      :class="{ 'is-invalid': errors.has('email') }"
                      aria-describedby="email-input-live-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="email-input-live-feedback">
          {{ errors.first("email") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <span>Please note that a verification email will be sent to the new email address. <br>
            Until the new email address is verified, your current email will continue to be used for your account.<br>
            Follow these steps to verify your new email:<br>
                  1. Click the 'Save' button below to receive an account verification email.<br>
                  2. Follow instructions in that email to verify your new email address.<br><br>
                  <i>Note: The account verification email will expire after 30 days</i>
      </span>
    </div>

    <template slot="modal-footer">
      <b-btn variant="secondary" @click="() => { this.resetModal(); this.$refs.updateEmailModal.hide() }">Cancel
      </b-btn>
      <b-btn variant="primary" @click="save()" :disabled="isLoadingUpdate || editedEmail === userEmail">
        <b-spinner v-if="isLoadingUpdate" small></b-spinner>
        Save
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "UpdateEmailModal",
  data() {
    return {
      editedEmail: null,
    }
  },
  created() {
    this.editedEmail = this.userEmail
  },
  watch: {
    userEmail(newVal) {
      if (newVal) {
        this.editedEmail = this.userEmail
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoadingUpdate: "user/profile/isLoadingUpdate",
      userEmail: "user/profile/email",
    }),
  },
  methods: {
    ...mapActions({
      updateUserProfile: 'user/profile/updateUserProfile',
    }),
    resetModal() {
      this.editedEmail = this.userEmail
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result && this.editedEmail !== this.userEmail) {
          this.updateUserProfile({changeEmail: this.editedEmail}).then(update => {
            if (update) {
              this.$refs.updateEmailModal.hide()
            }
          })
        }
      })
    },
  }
}
</script>

<style class="scss" scoped>
</style>
